export default __webpack_public_path__ + "static/media/map-pin-seven-rooms.6971141d.svg";